import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, ReplaySubject, throwError } from 'rxjs';
import { catchError, first, take } from 'rxjs/operators';
import { Note } from '../interface/note';
import { Uuid } from '../interface/response/uuid';
import { CountedAndPaginated } from '../interface/response/counted-and-paginated';
import { Note as NoteInterface } from '../interface/note';
import {FilterService} from "./filter.service";

@Injectable({
  providedIn: 'root'
})
export class NoteService {
  private readonly notesListSubject: ReplaySubject<CountedAndPaginated<Note>>
    = new ReplaySubject<CountedAndPaginated<Note>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) {}

  public loadList(page: number, pageSize: number, filters: object, sort?: { sortBy?: string, sortOrder?: string }): void {
    const sortBy = sort?.sortBy || 'meetingDateTime';
    const sortOrder = sort?.sortOrder || 'ASC';

    this.httpClient.get(`/rest/crm/note?page=${page + 1}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<Note>) => {
        this.notesListSubject.next(result);
      });
  }

  public getNote(uuid: string): Observable<NoteInterface> {
    return this.httpClient.get(`/rest/crm/note/${uuid}`)
      .pipe(first()) as Observable<NoteInterface>;
  }

  public addNote(formData: object): Observable<Uuid> {
    return this.httpClient.post<Uuid>('/rest/crm/note', formData)
      .pipe(take(1));
  }

  public updateNote(uuid: string, updatedNote: Partial<Note>): Observable<Note> {
    return this.httpClient.put<Note>(`/rest/crm/note/${uuid}`, updatedNote)
      .pipe(first());
  }

  public deleteNote(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/note/${uuid}`)
      .pipe(first());
  }

  downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/note/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public getNotesListSubject(): ReplaySubject<CountedAndPaginated<Note>> {
    return this.notesListSubject;
  }
}
